import React from "react";

export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-black/10 py-6 ${className}`} data-testid="editorial-marquee">
      <div className="dd-marquee flex whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl md:text-5xl text-[#0E0F12] px-8">
              {t}
            </span>
            <span className="text-gramur text-2xl">✶</span>
          </span>
        ))}
      </div>
    </div>
  );
}
